// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

// Types
import { SubjectId } from "@carnegie-learning/common-types";

@Component({
    selector: "bundle-directions",
    templateUrl: "./bundle-directions.component.html",
    styleUrls: [
        "./bundle-directions.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class BundleDirectionsComponent implements OnInit {
    @Input() subjectId: SubjectId;
    @Input() directions: string;
    @Input() objectives: any;
    @Input() fontSize: string;

    constructor() {}

    ngOnInit(): void {}
}
